import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Set REACT_APP_API_URL to point at a different backend (see .env.local for
// local development). CRA inlines this at build time, so CI must supply it.
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://prjx.us",
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      // If FormData, set the Content-Type header to multipart/form-data
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      // For other types of data, set the Content-Type header to application/json
      config.headers["Content-Type"] = "application/json";
    }

    const authToken = localStorage.getItem("token");

    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => {
    toast.error("An error occurred while sending the request."); // Display a toast for request errors
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    // if 401 then redirect to login
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    // Toast successes for writes only. Reads also carry a message ("Report
    // retrieved successfully"), and toasting those meant every page load —
    // and every dashboard filter change — threw up a pointless notification.
    const method = (response.config?.method || "get").toLowerCase();
    const isMutation = method !== "get";

    if (response.status === 200 && isMutation && response.data?.message) {
      toast.success(response.data.message);
    }
    return response;
  },
  (error) => {
    console.error(error);
    // Background calls (the silent session refresh) opt out of toasts —
    // a failed refresh shouldn't interrupt someone who hasn't touched
    // anything, but a genuinely dead token still logs them out below.
    const silent = error.config?.silent === true;

    if (error.response && error.response.status === 401) {
      if (!silent) toast.error(error.response.data.message);
      localStorage.clear();
      window.location.href = "/";
    } else if (!silent && error.response && error.response.status === 500) {
      toast.error("Server error. Please try again later.");
    } else if (!silent && error.response) {
      toast.error(error.response.data?.message || "Something went wrong.");
    } else if (!silent) {
      // No response at all — offline, DNS failure, CORS, timeout. Reading
      // error.response.data here used to throw inside the interceptor.
      toast.error("Can't reach the server. Check your connection and try again.");
    }
    return Promise.reject(error);
  }
);

export default instance;
